import { render, staticRenderFns } from "./jifen.vue?vue&type=template&id=822cadfe&"
import script from "./jifen.vue?vue&type=script&lang=js&"
export * from "./jifen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports